import { create } from "zustand";
import { IConfirmationModal } from "../interface/confirmationModal.interfase";

export type SaveReqConfirmModalStepType = 'confirm' | 'uploading-files' | 'uploading-request' | 'finished';

interface ISaveReqConfirmModalData {
    isModalOpen: boolean;
    isLoading: boolean;
    modalMessage: string;
    step: SaveReqConfirmModalStepType;
    savePermitProcessResult: IConfirmationModal;
}

interface ISaveReqConfirmModalStore {
    saveReqConfirmModalData: ISaveReqConfirmModalData;
    openSaveReqConfirmModal: () => void;
    closeSaveReqConfirmModal: () => void;
    setIsLoading: (isLoading: boolean, message?: string) => void;
    setModalMessage: (message: string) => void;
    setStep: (step: SaveReqConfirmModalStepType) => void;
    setSavePermitProcessResult: (result: IConfirmationModal) => void;
}

const initConfirmationModal: IConfirmationModal = {
    asmachta: '',
    permitRequestId: -1,
    amountPayed: 0,
    hasReceipt: false,
    receiptUrl: '',
}

const initSaveReqConfirmModalData: ISaveReqConfirmModalData = {
    isModalOpen: false,
    isLoading: false,
    modalMessage: '',
    step: 'confirm',
    savePermitProcessResult: { ...initConfirmationModal },
};

export const useSaveReqConfirmModalStore = create<ISaveReqConfirmModalStore>()((set) => ({
    saveReqConfirmModalData: initSaveReqConfirmModalData,
    openSaveReqConfirmModal: () => set((state) => ({
        ...state,
        saveReqConfirmModalData: {
            // reset the data
            ...initSaveReqConfirmModalData,
            isModalOpen: true,
        }
    })),
    closeSaveReqConfirmModal: () => set((state) => ({
        ...state,
        saveReqConfirmModalData: {
            // reset the data
            ...initSaveReqConfirmModalData,
            isModalOpen: false,
        }
    })),
    setIsLoading: (isLoading: boolean, message: string = '') => set((state) => ({
        ...state,
        saveReqConfirmModalData: {
            ...state.saveReqConfirmModalData,
            isLoading,
            modalMessage: message,
        }
    })),
    setModalMessage: (message: string) => set((state) => ({
        ...state,
        saveReqConfirmModalData: {
            ...state.saveReqConfirmModalData,
            modalMessage: message,
        }
    })),
    setStep: (step: SaveReqConfirmModalStepType) => set((state) => ({
        ...state,
        saveReqConfirmModalData: {
            ...state.saveReqConfirmModalData,
            step,
        }
    })),
    setSavePermitProcessResult: (result: IConfirmationModal) => set((state) => ({
        ...state,
        saveReqConfirmModalData: {
            ...state.saveReqConfirmModalData,
            savePermitProcessResult: result,
        }
    })),
}));

export const useSelectSaveReqConfirmModalData = () => {
    return useSaveReqConfirmModalStore((state) => state.saveReqConfirmModalData);
}
export const useOpenSaveReqConfirmModal = () => {
    return useSaveReqConfirmModalStore((state) => state.openSaveReqConfirmModal);
}
export const useCloseSaveReqConfirmModal = () => {
    return useSaveReqConfirmModalStore((state) => state.closeSaveReqConfirmModal);
}
export const useSetIsLoadingSaveReqConfirmModal = () => {
    return useSaveReqConfirmModalStore((state) => state.setIsLoading);
}
export const useSetModalMessageSaveReqConfirmModal = () => {
    return useSaveReqConfirmModalStore((state) => state.setModalMessage);
}
export const useSetStepSaveReqConfirmModal = () => {
    return useSaveReqConfirmModalStore((state) => state.setStep);
}
export const useSetSavePermitProcessResult = () => {
    return useSaveReqConfirmModalStore((state) => state.setSavePermitProcessResult);
}